import { c as _c } from "react/compiler-runtime";
import { Box, Heading, HStack, Icon, Text, VStack } from '@chakra-ui/react';
import { UserAvatar } from '@src/components/sco/Account/UserAvatar';
import { ErrorState } from '@src/components/sco/ErrorState';
import { NextLink } from '@src/components/sco/utilities/NextLink';
import { ScoUser } from '@src/graphql-types';
import { gql } from '@src/lib/gql';
import React from 'react';
import { LuMapPin, LuRocket, LuTags } from 'react-icons/lu';
type MemberCardProps = {
  member: ScoUser;
  href?: string;
};
export const MemberCard = props => {
  const $ = _c(34);
  const member = props.member;
  if (!member) {
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t0 = <ErrorState>Null Member</ErrorState>;
      $[0] = t0;
    } else {
      t0 = $[0];
    }
    return t0;
  }
  let t0;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      border: "1px solid",
      borderColor: "colorPalette.border"
    };
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const t1 = props.href || `/members/${member.userId}`;
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      size: "lg"
    };
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== member) {
    t3 = <UserAvatar avatarProps={t2} disablePopover={true} disablePresence={true} noLink={true} user={member} />;
    $[3] = member;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== member.fullName) {
    t4 = <Heading size="lg">{member.fullName}</Heading>;
    $[5] = member.fullName;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== member.company.name) {
    t5 = <Text color="colorPalette.fg/60" fontWeight="medium" textStyle="sm">{member.company.name}</Text>;
    $[7] = member.company.name;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== t4 || $[10] !== t5) {
    t6 = <VStack align="stretch" gap={0}>{t4}{t5}</VStack>;
    $[9] = t4;
    $[10] = t5;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== t3 || $[13] !== t6) {
    t7 = <HStack backgroundColor="colorPalette.container/50" borderTopRadius="lg" gap={4} padding={4}>{t3}{t6}</HStack>;
    $[12] = t3;
    $[13] = t6;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  let t8;
  if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <Icon asChild={true} aria-label="Industries" color="colorPalette.fg/60"><LuTags /></Icon>;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  let t9;
  if ($[16] !== member.company.industries) {
    t9 = member.company.industries.map(_temp).join(", ") || "-";
    $[16] = member.company.industries;
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  let t10;
  if ($[18] !== t9) {
    t10 = <HStack gap={4} width="full">{t8}<Box flexGrow={1}><Text color="colorPalette.fg/60" fontWeight="medium" textStyle="sm">{t9}</Text></Box></HStack>;
    $[18] = t9;
    $[19] = t10;
  } else {
    t10 = $[19];
  }
  let t11;
  if ($[20] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = <Icon asChild={true} aria-label="Stage" color="colorPalette.fg/60"><LuRocket /></Icon>;
    $[20] = t11;
  } else {
    t11 = $[20];
  }
  const t12 = member.company.stage?.title || "-";
  let t13;
  if ($[21] !== t12) {
    t13 = <HStack gap={4} width="full">{t11}<Box flexGrow={1}><Text color="colorPalette.fg/60" fontWeight="medium" textStyle="sm">{t12}</Text></Box></HStack>;
    $[21] = t12;
    $[22] = t13;
  } else {
    t13 = $[22];
  }
  let t14;
  if ($[23] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = <Icon asChild={true} aria-label="Location" color="colorPalette.fg/60"><LuMapPin /></Icon>;
    $[23] = t14;
  } else {
    t14 = $[23];
  }
  const t15 = member.location || member.company.location;
  let t16;
  if ($[24] !== t15) {
    t16 = <HStack gap={4} width="full">{t14}<Box flexGrow={1}><Text color="colorPalette.fg/60" fontWeight="medium" textStyle="sm">{t15}</Text></Box></HStack>;
    $[24] = t15;
    $[25] = t16;
  } else {
    t16 = $[25];
  }
  let t17;
  if ($[26] !== t10 || $[27] !== t13 || $[28] !== t16) {
    t17 = <VStack flexGrow={1} gap={2} padding={4}>{t10}{t13}{t16}</VStack>;
    $[26] = t10;
    $[27] = t13;
    $[28] = t16;
    $[29] = t17;
  } else {
    t17 = $[29];
  }
  let t18;
  if ($[30] !== t1 || $[31] !== t17 || $[32] !== t7) {
    t18 = <VStack asChild={true} align="stretch" bgColor="colorPalette.muted" border="1px solid" borderColor="transparent" borderRadius="lg" boxShadow="xs" gap={0} justify="stretch" width="full" _hover={t0}><NextLink href={t1}>{t7}{t17}</NextLink></VStack>;
    $[30] = t1;
    $[31] = t17;
    $[32] = t7;
    $[33] = t18;
  } else {
    t18 = $[33];
  }
  return t18;
};
MemberCard.fragments = {
  ScoUser: () => gql`
    fragment _ on ScoUser {
      id
      firstName
      lastName
      fullName
      pictureUrl
      slug
      title
      bio
      location
      company {
        id
        name
        industries {
          id
          title
        }
        stage {
          id
          title
        }
        location
      }
    }
  `
};
function _temp(i) {
  return i.title;
}